import React from 'react';

// Animated toggle switch. Drop-in replacement for `<input type="checkbox">`
// in the share modals — same on/off semantics, prettier slide.
const Toggle = ({ checked, onChange, disabled, accent }) => (
    <label className={`toggle-switch ${disabled ? 'is-disabled' : ''} ${accent ? `toggle-accent-${accent}` : ''}`}>
        <input
            type="checkbox"
            checked={!!checked}
            disabled={disabled}
            onChange={onChange}
        />
        <span className="toggle-track" />
        <span className="toggle-thumb" />
    </label>
);

export default Toggle;
